import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const saved = sessionStorage.getItem(this._key)
    if (saved !== null) {
      this.element.scrollLeft = parseInt(saved)
      if (!document.documentElement.hasAttribute("data-turbo-preview")) {
        sessionStorage.removeItem(this._key)
      }
    }
  }

  sort(event) {
    event.preventDefault()
    sessionStorage.setItem(this._key, this.element.scrollLeft)
    Turbo.visit(event.currentTarget.href)
  }

  get _key() {
    return `scroll:${window.location.pathname}`
  }
}
